import React,{ useState, useEffect,useRef } from 'react'
import { Card } from 'primereact/card';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { deleteVulnerability, getAllVulnerabilities,createVulnerability,editVulnerability } from '../../api/axiosVulnerabilities';
import { Toast } from 'primereact/toast';
import { AllToasts } from '../../components/Toasts/AllToasts';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';  
import { useNavigate } from 'react-router-dom';
import { useContext } from 'react';
import DataContext from '../../context/DataContext';
import DeleteDialog from '../../components/dialogs/DeleteDialog';
import { Dialog } from 'primereact/dialog';
import SearchToolBar from '../../components/buttonActions/SearchToolBar';
import TableActions from '../../components/buttonActions/TableActions';







const Vulnerabilities = () => {
  const { vulnerabilities, setVulnerabilities, setFetcherror } = useContext(DataContext);
 
  const toast = useRef(null);
  const [globalFilter, setGlobalFilter] = useState("");
  const navigate = useNavigate()


  const [addItemeDialogVisible, setAddItemDialogVisible] = useState(false);
  const [editDialogVisible, setEditDialogVisible] = useState(false);
  const [deleteDialogVisible, setDeleteDialogVisible] = useState(false);
  
  const [selectedId, setSelectedId] = useState(); //Track Id for Deleting or Editing
  
  const [vulnerability, setVulnerability] = useState("");
  const [editedVulnerability, setEditedVulnerability] = useState("");
  


 

  const NewTitle = "All Vulnerabilities";
  useEffect(() => {
    
    getAllVulnerabilities(setVulnerabilities, setFetcherror);
    
  }, []);


  const filteredVulnerabilities = vulnerabilities.filter((item) => item.name.toLowerCase().includes(globalFilter.toLowerCase()));
  const filteredReversedVulnerabilities = filteredVulnerabilities.reverse();
  
  const handleAllToasts = (statusNum, msg) => {
    AllToasts(statusNum, msg, toast);
  };

  // Delete Dialogue
  const deletefunction = (pkid, setVulnerabilities, setFetcherror, handleAllToasts) => {
    return () => {
      deleteVulnerability(pkid, setVulnerabilities, setFetcherror, handleAllToasts);
    };
  };
  const deletedialogHeader = "Confirm Delete";
  const deletedialogContents = (
      <p>Do you really want to delete this Vulnerability?, Click "Yes" to Proceed or "No" to Cancel</p>
  );

  const getItemtoEdit = (pkid, items) => {
    const foundItem = items.find((item) => item.id === pkid);
    setEditedVulnerability(foundItem?.name);
   
   }

  
  return (

    
    <div className="card">
      <Toast ref={toast} />
      
      <Card title={ NewTitle}>
          <SearchToolBar
              setAddItemDialogVisible={setAddItemDialogVisible}
              globalFilter={globalFilter}
              setGlobalFilter={setGlobalFilter}
              searchPlaceholder="Vulnerabilities"
              createLabel="Vulnerability"
          />
        
        <DataTable
          value={filteredVulnerabilities}
          showGridlines
          paginator
          rows={10}
          rowsPerPageOptions={[5, 10, 20]}
          emptyMessage="No vulnerabilities found"
        >
                    <Column header="S/N" body={(rowData) => vulnerabilities.indexOf(rowData)+1 } sortable> </Column>
                    <Column header="Name"   body={(rowData) => rowData.name} sortable></Column>
                    <Column header="Actions" body={(rowData) => (  
                            
                                  <TableActions
                                    id={rowData.id}
                                    data={vulnerabilities}
                                    getItemtoEdit={getItemtoEdit}
                                    setSelectedId={setSelectedId}
                                    setEditDialogVisible={setEditDialogVisible}
                                    setDeleteDialogVisible={ setDeleteDialogVisible}
                                  />
                        
                          )}>
                    </Column>
        </DataTable>

      
        
        {addItemeDialogVisible &&
          
          <div className="card flex justify-content-center">
          <Dialog className='-mt-8' header="New Vulnerability" visible={addItemeDialogVisible} style={{ width: '25vw' }} onHide={() => setAddItemDialogVisible(false)} >
              <form onSubmit={(e) => { 
                e.preventDefault();
                createVulnerability(vulnerability, setVulnerability, setFetcherror, handleAllToasts, setVulnerabilities);
                if (vulnerability) { setAddItemDialogVisible(false); }
              }}>
                  <InputText
                    className='w-full mb-4'
                    type="text"
                    placeholder="Enter Vulnerability Name"
                    value={vulnerability}
                    onChange={(e) => setVulnerability(e.target.value)}
                  />

                  
                 <div  className="card flex justify-content-end">
                  <Button label="Cancel" icon="pi pi-times" onClick={() => { setAddItemDialogVisible(false); setVulnerability("");  }} className="p-button-text px-3 py-1 text-sm" />
                  <Button type='submit' label="Save" icon="pi pi-check"  autoFocus  className="px-3 py-1 text-sm"/>
                </div>
            </form>
          </Dialog>
         </div>
        
        }
        



        {
          editDialogVisible &&
          <div className="card flex justify-content-center">
          <Dialog className='-mt-8' header="Edit Vulnerability" visible={editDialogVisible} style={{ width: '25vw' }} onHide={() => setEditDialogVisible(false)} >
              <form onSubmit={(e) => { 
                e.preventDefault();
                editVulnerability( selectedId, editedVulnerability, setEditedVulnerability,  setFetcherror, handleAllToasts, setVulnerabilities);
                if (editedVulnerability) { setEditDialogVisible(false); }
              }}>
                  <InputText
                    className='w-full mb-4'
                    type="text"
                    // disabled
                    placeholder="Enter Vulnerability Name"
                    value={editedVulnerability}
                    onChange={(e) => setEditedVulnerability(e.target.value)}
                  />

                  
                 <div  className="card flex justify-content-end">
                  <Button label="Cancel" icon="pi pi-times" onClick={() => { setEditDialogVisible(false); setVulnerability("");  }} className="p-button-text px-3 py-1 text-sm" />
                  <Button type='submit' label="Save" icon="pi pi-check"  autoFocus  className="px-3 py-1 text-sm"/>
                </div>
            </form>
          </Dialog>
         </div>
        
        }

        
        
        {
                deleteDialogVisible &&
        
                <DeleteDialog
                    dilogvisible={deleteDialogVisible}
                    setDilogvisibleVisible={setDeleteDialogVisible}
                    deletefucton={deletefunction(selectedId, setVulnerabilities, setFetcherror, handleAllToasts)}
                    dialogHeader={deletedialogHeader}
                    dialogContents={ deletedialogContents}
                    
                 />
      } 
       
                
      </Card>
      
    </div>
  )
}

export default Vulnerabilities


